import { CheckText } from '../../../components/common/CheckText';
import { H5, P1 } from '../../../styles/FontStyles';
import { Box, Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';

interface WarningBoxType {
  text: string;
  virtualOfficeButtonText: string;
  buttonText: string;
  virtualOfficeButtonFn: () => void;
  buttonFn: () => void;
}

export const WarningBox = ({
  text,
  virtualOfficeButtonText,
  buttonText,
  virtualOfficeButtonFn,
  buttonFn
}: WarningBoxType) => {
  return (
    <>
      <Box blue>
        <Flexed column>
          <Flexed column center>
            <Icon mb='12'>
              <IconWarningMark size='50' />
            </Icon>
            <H5 mb='20' color={colors.neutral500}>
              WARNING
            </H5>
          </Flexed>

          <P1 mb='20' left bold>
            {text}
            <br />
          </P1>

          <P1 mb='20' left bold>
            <span style={{ color: 'red' }}>EXPIRED BACK OFFICE</span> RESULTS
            IN:
          </P1>
          <Flexed column>
            <CheckText x text='No bonuses or limited weekly cap' />
            <CheckText x text='No BV points accumulation' />
          </Flexed>
        </Flexed>
      </Box>
      <Button onClick={buttonFn}> {buttonText} </Button>
      <Button onClick={virtualOfficeButtonFn} textButton>
        {virtualOfficeButtonText}
      </Button>
    </>
  );
};
